<template>
  <div ref="productListConainer" class="product-list-container">
    <div class="product-search-container" v-if="showSearch">
      <Textbox
        type="search"
        placeholder="Search for a product..."
        @search="onSearch"
      />
    </div>

    <div
      v-if="isLoading"
      class="product-grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2"
    >
      <ProductCard v-for="num in 12" :key="num" placeholder />
    </div>
    <div
      class="py-4"
      v-else-if="!isLoading && !Object.keys(productChunks || {})?.length"
    >
      <i>
        No products found
        {{
          searchString ? "matching the keyword '" + searchString + "'" : ""
        }}...
      </i>
    </div>
    <Paginate
      :page="page"
      v-else-if="productList.length"
      :items="productList"
      @page-change="onPageChange"
    >
      <template #activeItems="{ items, page }">
        <div
          class="product-grid xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2"
          v-if="isPageLoaded(page)"
        >
          <ProductCard
            v-for="item in items"
            :key="item.productId"
            :product="item"
            :language="language"
          />
        </div>
      </template>
    </Paginate>
  </div>
</template>

<script>
import Paginate from "../UI/Paginate.vue";
import Textbox from "../UI/Textbox.vue";
import ProductCard from "./ProductCard.vue";

export default {
  name: "ProductList",
  components: { ProductCard, Paginate, Textbox },
  emits: ["page-change", "new-page", "search"],
  props: {
    page: {
      type: Number,
      default: 0,
    },
    products: {
      type: Array,
      default: () => [],
    },
    productChunks: {
      type: Object,
      default: () => {},
    },
    language: {
      type: String,
      default: "en",
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    isLoading: Boolean,
  },
  model: {
    event: "new-page",
    prop: "page",
  },
  methods: {
    onPageChange(e) {
      if (e.current !== e.prev) {
        this.$refs["productListConainer"].scrollIntoView({
          behavior: "smooth",
        });
      }
      this.$emit("new-page", e.current);
      this.$emit("page-change", e);
    },
    isPageLoaded(page) {
      return this.productChunks?.[page]?.loaded;
    },
    onSearch(e) {
      this.$emit("search", e.value);
    },
  },
  computed: {
    productList() {
      if (!this.productChunks) {
        return this.products;
      }

      const prod = Object.keys(this.productChunks).map((key) => {
        if (this.productChunks[key].loaded) {
          return this.productChunks[key].products;
        }

        return this.productChunks[key].ids;
      });

      return prod.flat();
    },
    searchString() {
      return this.$route.query.search || null;
    },
  },
};
</script>

<style>
.product-list-container {
  display: flex;
  flex-direction: column;
}

.product-search-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1rem;
}

.product-grid {
  display: grid;
  gap: 1.4rem;
}
</style>
